<script setup lang="ts">
import { computed, ref } from 'vue'
import { useLocalStorageAvailability } from '@/composables/localStorage'

const getLocalStorage = () => {
  const storage: Record<string, unknown> = {}

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)

    if (key) {
      try {
        storage[key] = JSON.parse(localStorage.getItem(key) || '')
      } catch {
        storage[key] = localStorage.getItem(key)
      }
    }
  }

  return storage
}
const storageItems = computed(() => {
  const storage = getLocalStorage()
  return Object.entries(storage).map(([key, value]) => ({
    key,
    value,
    type: typeof value,
  }))
})

const modal = ref(true)
const closeModal = () => {
  modal.value = false
}
</script>

<template>
  <div
    v-if="modal"
    class="fixed bottom-0 right-0 z-[100] flex max-h-[80vh] w-full flex-col gap-4 overflow-auto bg-gray-900 p-4 text-xs text-white"
  >
    <div class="flex items-center justify-between border-b border-gray-700 pb-3">
      <div class="flex items-center gap-2">
        <h3 class="font-bold">Debug Console</h3>
        <button class="rounded-full bg-gray-700 p-1 text-xs" @click="closeModal">X</button>
      </div>
    </div>
    <p>Accept localStorage: {{ useLocalStorageAvailability() }}</p>
    <div v-for="item in storageItems" :key="item.key" class="pt-2">
      <div class="flex items-start justify-between">
        <span class="font-medium text-gray-300">{{ item.key }}</span>
        <span class="text-gray-500">{{ item.type }}</span>
      </div>
      <pre class="mt-1 overflow-auto rounded bg-gray-950 p-2 text-[10px]">{{
        typeof item.value === 'string' ? item.value : JSON.stringify(item.value, null, 2)
      }}</pre>
    </div>
  </div>
</template>
